import {Controller} from "@hotwired/stimulus"
import L from "leaflet"

// Connects to data-controller="monitoring--map--marker"
export default class extends Controller {

  connect() {
  }

  iniIcon(markerHtml = '') {
    return L.divIcon({
      className: '',
      iconSize: [0, 0],
      iconAnchor: [13, 24],
      popupAnchor: [0, -20],
      html: markerHtml
    });
  }

  addMarker(place, markerToMap = false, markerHtml = '', bindPopup = '') {
    const [latitude, longitude] = place;
    const icon = this.iniIcon(markerHtml);
    let marker;
    if (markerToMap) {
      if (bindPopup === '') {
        bindPopup = `<div>Latitude: ${latitude}</div><div>Longitude: ${longitude}</div>`, {minWidth: 500}
      }

      marker = new L.marker([latitude, longitude], {icon}).addTo(this.map)
        .bindPopup(
          bindPopup
        );

    } else {
      marker = new L.marker([latitude, longitude], {icon})
        .bindPopup(
          ``, {minWidth: 500}
        );

    }

    return marker;
  }


}
